var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoLocalizacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.8 0 0 3.27277 0 8.33439C0 11.5665 2.45 15.3678 7.34 19.7484C7.72 20.0839 8.29 20.0839 8.67 19.7484C13.55 15.3678 16 11.5665 16 8.33439C16 3.27277 12.2 0 8 0ZM8 10.1639C6.9 10.1639 6 9.24914 6 8.13111C6 7.01309 6.9 6.09834 8 6.09834C9.1 6.09834 10 7.01309 10 8.13111C10 9.24914 9.1 10.1639 8 10.1639Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoLocalizacion);
export default __webpack_public_path__ + "static/media/icono_localizacion.5a695fddccc6f2fd4022c33cc5b5354c.svg";
export { ForwardRef as ReactComponent };